import { useDonationsContext } from 'hb-react/shared/apps/Events/contexts/DonationsContext';

export const useTicketInformationStepSubmit = ({
  guestsContext,
  setValuesStep2,
  billingStepFlow,
  freeTicketsFlow,
  withBillingStepWorkflow = true,
}) => {
  const { donations, displayed, openModal } = useDonationsContext();

  return {
    onSubmit: async (values, { setSubmitting }) => {
      setValuesStep2(values);

      if (guestsContext?.actions?.saveGuests) {
        guestsContext.actions.saveGuests();
      }

      if (donations.length > 0 && !displayed) {
        return openModal({
          onSubmitSuccess: ({ donated }) => {
            if (donated || withBillingStepWorkflow) {
              return billingStepFlow();
            }

            return freeTicketsFlow();
          },
        });
      }

      if (withBillingStepWorkflow) {
        setSubmitting(false);

        return billingStepFlow();
      }

      await freeTicketsFlow();

      setSubmitting(false);
    },
  };
};
